import React, { useState } from "react";
import { authApi } from "../../backend_urls/authApi";
import LoadingSpinner from "../../components/loaders/LoadingSpinner";

const RegistrationPage = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        email: "",
        user_full_name: "",
        contact: "",
        password: "",
        confirm_password: ""
    });

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (data.password !== data.confirm_password) {
            alert("Passwords do not match");
            return;
        }

        setLoading(true);
        try {
            await authApi.userRegistration({ ...data });
            alert("User registered successfully");
        } catch (error) {
            console.error(error);
            alert("Error while registering user");
        } finally { setLoading(false) };
    };

    return ( loading ? <LoadingSpinner /> :
        <div style={{paddingTop: "100px"}}>
            <h1>Users Registration Page</h1>
            <form onSubmit={handleSubmit}>
                <input name="email" placeholder="Email ID" onChange={handleChange} />

                <input name="user_full_name" placeholder="Full Name" onChange={handleChange} />

                <input name="contact" placeholder="Contact Number" onChange={handleChange} />

                <input name="password" placeholder="Password" onChange={handleChange} />
                <input name="confirm_password" placeholder="Confirm Password" onChange={handleChange} />

                <button type="submit">Register</button>
            </form>
        </div>
    );
};

export default RegistrationPage;
